/* eslint-disable security/detect-object-injection */
/**
 * Generic cache helper for getting and setting values in a cache object.
 * This can be used for any object-based cache, not just Learning Journey.
 */
export class CacheHelper<T extends object> {
  /**
   * Retrieves the cached value for a given key if available and valid
   */
  static getCachedValue<K extends string, V>(key: K, cache: Record<K, V>, valueKey: keyof V): string | null {
    const descriptor = Object.getOwnPropertyDescriptor(cache, key);
    if (descriptor && descriptor.value && typeof descriptor.value[valueKey] === 'string') {
      return descriptor.value[valueKey] as string;
    }
    return null;
  }

  /**
   * Updates the cached value for a given key and persists to localStorage.
   */
  static updateCachedValue<K extends string, V>(
    key: K,
    cache: Record<K, V>,
    valueKey: keyof V,
    newValue: string,
    localStorageKey: string
  ): void {
    const descriptor = Object.getOwnPropertyDescriptor(cache, key);
    if (descriptor && descriptor.value) {
      descriptor.value[valueKey] = newValue as V[keyof V];
      localStorage.setItem(localStorageKey, JSON.stringify(cache));
    }
  }
}
